<template>
  <div>
    <el-form label-width="120px" >
      <el-form-item label="公式账号" class="form-line">
        <el-input v-model.number="phone_number" class="input-line"></el-input>
		<el-button @click="getProductList" class="ml">查询</el-button>
      </el-form-item>
	  <el-form-item label="" v-show="productList.length">
	    <el-checkbox-group v-model="product_ids" style="display: inline-block;margin-right: 10px;">
	      <el-checkbox v-for="(item,index) in productList" :key="index" :label="item.id"  name="type">{{item.name}}</el-checkbox>
	    </el-checkbox-group>
	  </el-form-item>
      <el-form-item label="公司名" class="form-line">
        <el-input v-model.number="name" class="input-line"></el-input>
      		<el-button @click="getfactoryList" class="ml">查询</el-button>
      </el-form-item>
      <el-form-item label="" v-show="factoryList.length">
        <el-radio-group v-model="factory_id" style="display: inline-block;margin-right: 10px;">
          <el-radio v-for="(item,index) in factoryList" :key="index" :label="item.id"  name="type">{{item.company}}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="submit">确定</el-button>

  </div>
</template>

<script>
export default {
  data:()=>({
    obj:{
      phone_number:'',
      phone_number_makesure:'',
      year:1000,
      model:['3'],
      note: "",
	  user_count: 1,
	  annual_fee: '',
	  customer_number: ''
    },
    yearList:[
	  {label:'半年',value:0.5},
      {label:'1年',value:1},
      {label:'2年',value:2},
      {label:'3年',value:3},
      {label:'永久',value:1000},
    ],
	annual: false,
	phone_number: '',
	productList: [],
	name: '',
	factoryList: [],
	product_ids: [],
	factory_id: ''
  }),
  methods:{
    submit(){
		var params = {
			product_ids: this.product_ids,
			factory_id: this.factory_id
		}
      this.$axios.post('admin-send-products-to-factory',params).then(res=>{
        if(res.code==1){
		  this.$message.success(res.message)
          this.resetForm()
        }else{
          this.$message.error(res.message)
        }
      }).catch((err) =>{
		  this.$message.error(err.message)
	  })
    },
	getProductList() {
		var params = {
			phone_number: this.phone_number
		}
		this.$axios.get('admin-get-company-products', params).then(res => {
			this.productList = res;
		}).catch((err) =>{
			this.$message.error(err.message)
		});
	},
	getfactoryList() {
		var params = {
			name: this.name
		}
		this.$axios.get('admin-get-factory-list', params).then(res => {
			if(!res.code) {
				this.$message.error(res.message)
				return 
			}
			this.factoryList = res.data;
		});
	},
	resetForm() {
		this.phone_number = ''		this.productList = []		this.name = ''		this.factoryList = []		this.product_ids = []		this.factory_id = ''
	}
  }

}
</script>

<style scoped lang="scss">
	.input-label{
		display: inline-block;
		width: 70px;
	}
	.form-line{
		margin-top: 10px;
	}
	.input-line{
		width: 300px;
		display: inline-block;
	}
	.ml{
		margin-left: 10px;
	}
</style>